import React from 'react'
import { Container, Button } from '@mui/material'

import SignInForm from './SignInForm'
import SignUpFormEmailVerification from './SignUpFormEmailVerification'
import SignUpForm from './SignUpForm'
import ForgottenPasswordForm from './ForgottenPasswordForm'
import ResetPasswordForm from './ResetPasswordForm'
import ErrorPage from './ErrorPage'

import SignIn0 from './reference-forms/SignIn0'
import SignIn1 from './reference-forms/SignIn1'
import SignIn2 from './reference-forms/SignIn2'
import SignUp0 from './reference-forms/SignUp0'
import SignUp1 from './reference-forms/SignUp1'
import SignUp2 from './reference-forms/SignUp2'
import SignUp3 from './reference-forms/SignUp3'
import SignUpEmailInUse from './reference-forms/SignUpEmailInUse'
import ForgottenPassword0 from './reference-forms/ForgottenPassword0'
import ForgottenPassword1 from './reference-forms/ForgottenPassword1'
import ForgottenPassword2 from './reference-forms/ForgottenPassword2'
import ForgottenPassword3 from './reference-forms/ForgottenPassword3'
import ResetPassword0 from './reference-forms/ResetPassword0'
import ErrorPage0 from './reference-forms/ErrorPage0'

const steps = new Map<React.FC, React.ComponentType<{ id: string }>[]>([
  [SignUpForm, [SignUpEmailInUse, SignUp0, SignUp1, SignUp2, SignUp3]],
  [SignInForm, [SignIn0, SignIn1, SignIn2]],
  [SignUpFormEmailVerification, [SignUp0, SignUp1, SignUp2]],
  [ForgottenPasswordForm, [ForgottenPassword0, ForgottenPassword1, ForgottenPassword2, ForgottenPassword3]],
  [ResetPasswordForm, [ResetPassword0]],
  [ErrorPage, [ErrorPage0]],
])

const inputForms = [...steps.keys()].flatMap((form) => steps.get(form)!)

const Debugger: React.FC<{
  id: string
  native?: boolean
}> = ({ id, native }) => {
  const [index, setIndex] = React.useState(0)

  const increaseIndex = React.useCallback(
    () => setIndex((_index) => (_index === inputForms.length - 1 ? 0 : _index + 1)),
    [],
  )

  const Component = inputForms[index]

  React.useEffect(() => {
    if (native && !window.location.search.includes('native=true')) {
      let searchParams = new URLSearchParams(window.location.search)
      searchParams.set('native', 'true')
      let newurl =
        window.location.protocol +
        '//' +
        window.location.host +
        window.location.pathname +
        '?' +
        searchParams.toString()
      window.history.pushState({ path: newurl }, '', newurl)
    } else if (!native && window.location.search.includes('native=true')) {
      let searchParams = new URLSearchParams(window.location.search)
      searchParams.delete('native')
      let newurl =
        window.location.protocol +
        '//' +
        window.location.host +
        window.location.pathname +
        '?' +
        searchParams.toString()
      window.history.pushState({ path: newurl }, '', newurl)
    }
  }, [native])

  React.useEffect(() => {
    if (
      [...steps.keys()]
        .filter((form) => [SignInForm, SignUpFormEmailVerification, SignUpForm].includes(form))
        .flatMap((form) => steps.get(form)!)
        .includes(Component)
    ) {
      if (!window.location.search.includes('page=B2C_1A_SignUpOrSignIn')) {
        let searchParams = new URLSearchParams(window.location.search)
        searchParams.set('page', 'B2C_1A_SignUpOrSignIn')
        let newurl =
          window.location.protocol +
          '//' +
          window.location.host +
          window.location.pathname +
          '?' +
          searchParams.toString()
        window.history.pushState({ path: newurl }, '', newurl)
      }
    } else {
      if (!window.location.search.includes('page=b2c_1a_passwordreset')) {
        let searchParams = new URLSearchParams(window.location.search)
        searchParams.set('page', 'b2c_1a_passwordreset')
        let newurl =
          window.location.protocol +
          '//' +
          window.location.host +
          window.location.pathname +
          '?' +
          searchParams.toString()
        window.history.pushState({ path: newurl }, '', newurl)
      }
    }
  }, [Component])

  return (
    <Container
      sx={{
        backgroundColor: (theme) => theme.palette.background.paper,
        display: 'flex',
        justifyContent: 'center',
        padding: 2,
      }}
    >
      <Button onClick={increaseIndex}>Advance</Button>
      {/* <div> */}
      <div style={{ display: 'none' }}>
        <Component id={id} />
      </div>
    </Container>
  )
}

export default Debugger
